<script setup lang="ts">
  import type { CorrectedWord, FillLogsPaperTarget, FillLogsSection } from '../model/fill-logs-text';
  import FillLogsFieldGrid from './FillLogsFieldGrid.vue';
  import FillLogsRowsTable from './FillLogsRowsTable.vue';

  defineProps<{ sections: FillLogsSection[]; correctedWord: CorrectedWord }>();
  const emit = defineEmits<{ (e: 'show', target: FillLogsPaperTarget): void }>();
</script>

<template>
  <div
    class="flex flex-col gap-6 px-6 pt-4 pb-6"
    data-testid="fill-logs-all"
  >
    <section
      v-for="section in sections"
      :key="section.key"
      class="flex flex-col gap-3"
      data-testid="fill-logs-all-section"
    >
      <h3
        v-if="section.title"
        class="border-b border-gray-02 pb-1.5 text-xs/4 font-semibold uppercase tracking-[.04em] text-gray-07 [overflow-wrap:anywhere]"
      >
        {{ section.title }}
      </h3>
      <template
        v-for="block in section.blocks"
        :key="block.key"
      >
        <FillLogsFieldGrid
          v-if="block.kind === 'fields'"
          :entries="block.entries"
          :corrected-word="correctedWord"
          @show="emit('show', $event)"
        />
        <FillLogsRowsTable
          v-else
          :columns="block.columns"
          :rows="block.rows"
          :corrected-word="correctedWord"
          @show="emit('show', $event)"
        />
      </template>
    </section>
  </div>
</template>
